import { ListView } from '@onegov/react-component-library';
import { Heading } from '@snsw/react-component-library';
import { PagePath } from 'shared/constants/pagePath';
import _ from 'lodash';
import { PlantDesignDrawingAndTechDetailsPage } from 'plantDesign/constants/plantDesignDrawingAndTechDetailsPage';
import { removeTechStandard } from 'plantDesign/redux/plantDesignDrawingAndTechSlice';
import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from '../DrawingsAndTechDetails.module.scss';

export const TechStandardListView = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    items = [],
    errorMessage = '',
    hasError = false,
    id = '',
    showHeading = true,
    showEditRemove = true,
    showAddButton = true,
  } = props;

  const PageConstant = PlantDesignDrawingAndTechDetailsPage.techStandardList;

  const onEditTechStandardClick = () => {
    const designTechStandards = _.cloneDeep(items);
    navigate(PagePath.plantDesignAddTechStandard, { state: { techStandards: designTechStandards } });
  };

  const onAddTechStandardClick = () => {
    let designTechStandards = _.cloneDeep(items);

    //max techstandards is 5
    if (designTechStandards.length >= 5) return;

    designTechStandards.push({});

    navigate(PagePath.plantDesignAddTechStandard, { state: { techStandards: designTechStandards } });
  };

  const onRemoveTechStandard = (index, techStandardDetails) => {
    dispatch(removeTechStandard(index));
  };

  const renderRowTitleTechStandardListView = (index, techStandard) => {
    return (
      <div key={`title_${index}`} className={styles.listViewTitle}>{`${(index + 1).toString().padStart(2, '0')} ${
        PageConstant.techStandardLabel
      }`}</div>
    );
  };

  const renderRowDetailsTechStandardListView = (index, techStandard) => {
    return (
      <Fragment key={`detail_${index}`}>
        <div className={styles.listViewDetailsValue}>
          {PageConstant.techStandardNumberLabel + ': ' + techStandard.number}
        </div>

        <div className={styles.listViewDetailsValue}>
          {PageConstant.yearOfPublicationLabel + ': ' + techStandard.yearOfPublication}
        </div>
      </Fragment>
    );
  };

  return (
    <>
      {showHeading && <Heading level={2}>{PageConstant.techStandardListTitle}</Heading>}
      <div>
        <strong>{PageConstant.techStandardListHelpMessage}</strong>
      </div>
      <div id={id}>
        <ListView
          title=""
          buttonAddTitle={`+ Add  ${items.length > 0 ? 'another' : 'a'}  technical standard`}
          items={items}
          confirmationTitle="Are you sure you want to remove this technical standard?"
          confirmationDescription="This will delete all details for the technical standard."
          onRemove={onRemoveTechStandard}
          maxItemLimit={5}
          renderRowTitle={renderRowTitleTechStandardListView}
          renderRowDetails={renderRowDetailsTechStandardListView}
          onAdd={onAddTechStandardClick}
          onEdit={onEditTechStandardClick}
          errorMessage={errorMessage}
          hasError={hasError}
          showEditRemove={showEditRemove}
          showAddButton={showAddButton}
        />
      </div>
    </>
  );
};
